"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { ArrowRight, Play, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-mesh pt-36 pb-20 md:pt-44 md:pb-28">
      <div className="bg-grid absolute inset-0" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 mb-7 bg-card/80 backdrop-blur-sm border border-border shadow-sm">
              <Sparkles size={13} className="text-primary" />
              <span className="text-xs font-medium text-muted-foreground">
                Trusted by 200+ growing teams
              </span>
            </div>

            <h1 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] font-semibold text-foreground leading-[1.06] mb-6">
              The HR Platform Built for Brilliant Work
            </h1>

            <p className="text-lg text-muted-foreground max-w-xl mb-9 leading-relaxed">
              AeronPay HRMS is your people enabler. From automation of people
              processes to creating an engaged and driven culture, AeronPay HRMS
              is all you need to build a good to great company.
            </p>

            <div className="flex flex-col sm:flex-row gap-3.5">
              <Link
                href="/book-demo"
                className="group inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-3.5 text-sm font-semibold shadow-[0_1px_0_0_rgba(255,255,255,0.15)_inset,0_8px_24px_-8px_hsl(217_91%_60%/0.6)] "
              >
                Book a demo
                <ArrowRight
                  size={16}
                  className="group-hover:translate-x-0.5 transition-transform"
                />
              </Link>
              <button className="inline-flex items-center justify-center gap-2 border border-border bg-card/60 backdrop-blur-sm rounded-full px-6 py-3.5 text-sm font-semibold text-foreground hover:bg-muted">
                <Play size={15} fill="currentColor" />
                Watch 2-min overview
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: 0.15,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden ">
              <Image
                src="/homepage/hero/hero-home.svg"
                alt="Team collaborating in a modern office"
                width={600}
                height={720}
                priority
                className="object-cover w-full h-[420px] md:h-[480px]"
              />
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.5 }}
              className="absolute top-5 -left-6 bg-card border border-border rounded-xl px-4 py-3 shadow-xl"
            >
              <div className="flex items-center gap-2">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-success" />
                </span>
                <span className="text-xs font-semibold text-foreground">
                  Leave approved
                </span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
